import { FC } from 'react';
import { Link } from '../../components/Link.client';
import { KEYWORDS } from '../../constants/Keywords';

interface Props {
  onClick?: () => void;
}

export const Keywords: FC<Props> = ({ onClick }) => (
  <div className="md:wrapper md:flex md:flex-wrap md:items-center md:justify-center md:gap-8">
    <div className="mb-2 flex items-end gap-3 px-4 md:mb-0 md:block">
      <p className="font-outfit text-xs font-bold text-red">KEYWORD</p>
      <p className="font-bold">人気キーワード</p>
    </div>
    <div className="flex items-center gap-1 md:flex-wrap md:justify-center md:overflow-x-auto overflow-x-scroll hidden-scrollbar">
      {KEYWORDS.map((keyword, i) => (
        <div
          key={i}
          className="rounded-sm border border-solid border-lightGray first:ml-4 last:mr-4 md:first:ml-0 md:first:mr-0"
        >
          <Link route="search" query={keyword} onClick={onClick}>
            <div className="flex gap-1 px-4 py-1 text-sm">
              <p className="font-outfit">#</p>
              <p className="whitespace-nowrap font-bold tracking-[0.45px]">{keyword}</p>
            </div>
          </Link>
        </div>
      ))}
    </div>
  </div>
);
